import React from 'react';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { Navigate } from 'react-router';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import DateObject from 'react-date-object';

export default class PersianHolidays extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            records: [],
            year: new DateObject({ calendar: persian }).year,
            showModal: false,
            editId: null,
            form: { persianYear: 0, month: 0, day: 0, title: '' },
            selectedDate: null
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });
        this.httpPost('api/v1/persianholiday/list', { year: this.state.year })
            .then(data => {
                if (data.status === 1) this.setState({ records: data.records, loading: false,data });
                else { this.showErorrMessage(data.message); this.setState({ loading: false }); }
            });
    };

    openModal = (holiday = null) => {
        if (holiday) {
            const dateObj = new DateObject({
                year: holiday.persianYear,
                month: holiday.month,
                day: holiday.day,
                calendar: persian
            });
            this.setState({
                showModal: true,
                editId: holiday.id,
                form: { ...holiday },
                selectedDate: dateObj
            });
        } else {
            this.setState({
                showModal: true,
                editId: null,
                form: { persianYear: this.state.year, month: 1, day: 1, title: '' },
                selectedDate: null
            });
        }
    };

    closeModal = () => this.setState({ showModal: false });

    handleDateChange = (date) => {
        if (!date) return;
        const jalali = new DateObject({ date, calendar: persian });
        this.setState({
            selectedDate: jalali,
            form: {
                ...this.state.form,
                persianYear: jalali.year,
                month: jalali.month,
                day: jalali.day
            }
        });
    };

    handleChange = (field, value) => {
        this.setState({ form: { ...this.state.form, [field]: value } });
    };

    save = () => {
        const { form, editId } = this.state;
        if (!form.title.trim()) { this.showErorrMessage('عنوان الزامی است'); return; }
        this.httpPost('api/v1/persianholiday/save', { id: editId || 0, ...form })
            .then(data => {
                if (data.status === 1) {
                    this.showSuccessMessage('ذخیره شد');
                    this.closeModal();
                    this.loadData();
                } else this.showErorrMessage(data.message);
            });
    };

    remove = (id) => {
        if (!window.confirm('حذف شود؟')) return;
        this.httpPost('api/v1/persianholiday/remove', { id })
            .then(data => {
                if (data.status === 1) { this.showSuccessMessage('حذف شد'); this.loadData(); }
                else this.showErorrMessage(data.message);
            });
    };

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        const { loading, records, year, showModal, form, selectedDate } = this.state;

        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            <Header data={this.state.data} />,
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">تعطیلات رسمی</h3>
                                        <p className="text-soft">سال {year} – {records.length} روز</p>
                                    </div>
                                    <div className="nk-block-head-content">
                                        <button className="btn btn-primary" onClick={() => this.openModal()}>
                                            <em className="icon ni ni-plus"></em> افزودن تعطیلی
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-4">
                                {records.map(h => {
                                    const dateStr = `${h.persianYear}/${h.month.toString().padStart(2, '0')}/${h.day.toString().padStart(2, '0')}`;
                                    return (
                                        <div className="col-md-6 col-lg-4" key={h.id}>
                                            <div className="card card-bordered holiday-card">
                                                <div className="card-inner">
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <div>
                                                            <h5 className="mb-1">{h.title}</h5>
                                                            <p className="mb-0 text-soft">{dateStr}</p>
                                                        </div>
                                                        <div className="btn-group">
                                                            <button className="btn btn-sm btn-icon btn-light" onClick={() => this.openModal(h)}>
                                                                <em className="icon ni ni-edit"></em>
                                                            </button>
                                                            <button className="btn btn-sm btn-icon btn-light" onClick={() => this.remove(h.id)}>
                                                                <em className="icon ni ni-trash"></em>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* مودال */}
                            {showModal && (
                                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.4)' }}>
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">{form.id ? 'ویرایش تعطیلی' : 'تعطیلی جدید'}</h5>
                                                <button className="close" onClick={this.closeModal}>&times;</button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="row g-3">
                                                    <div className="col-12">
                                                        <label className="form-label">تاریخ</label>
                                                        <DatePicker
                                                            calendar={persian}
                                                            locale={persian_fa}
                                                            value={selectedDate}
                                                            onChange={this.handleDateChange}
                                                            format="YYYY/MM/DD"
                                                            inputClass="form-control"
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <label className="form-label">عنوان تعطیلی</label>
                                                        <input className="form-control" value={form.title}
                                                            onChange={e => this.handleChange('title', e.target.value)}
                                                            placeholder="مثلاً عید نوروز" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-primary" onClick={this.save}>ذخیره</button>
                                                <button className="btn btn-secondary" onClick={this.closeModal}>انصراف</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>,
            <Footer />
        ];
        return contents;
    }
}